// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__pCzQD","label":"style_label__KSlLc"};